var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80985 21.137V23.9103H5.29409V21.137H1.80985ZM20.4889 13.1504V23.9103H23.9731V13.1504H20.4889ZM14.2634 16.2098V23.9103H17.7452V16.2098H14.2634ZM8.03784 18.2182V23.9103H11.5196V18.2182H8.03784Z",
    fill: "#00B3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0578 4.7812V26.0962H0.463833V29.1877H28.5927C29.4411 29.1877 30.1301 28.4944 30.1301 27.6407V4.7812H27.0578ZM20.1604 4.38643L20.4155 6.39481C20.4939 7.0141 21.0554 7.45081 21.6709 7.37433C22.2863 7.29537 22.7203 6.73036 22.6443 6.11107L21.9945 1.02351C21.9602 0.665754 21.7567 0.330202 21.4232 0.142688C21.1192 -0.0275558 20.7734 -0.0398923 20.4718 0.0760706L15.6022 1.96355C15.0236 2.18807 14.7367 2.84191 14.9598 3.42419C15.183 4.00647 15.8327 4.29514 16.4114 4.07062L18.0738 3.42666C16.252 5.91369 14.0698 7.99115 11.7134 9.6097C8.31992 11.9413 4.57822 13.3106 1.04495 13.5672C0.4246 13.6116 -0.0412727 14.152 0.00286267 14.7762C0.046998 15.4004 0.583978 15.8692 1.20432 15.8248C5.12501 15.546 9.25902 14.041 12.9811 11.4824C15.6586 9.64424 18.1278 7.2559 20.1604 4.38643Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthIcon);
export default __webpack_public_path__ + "static/media/growthIcon.3269024e6a2cbc43a43f21f38cad9847.svg";
export { ForwardRef as ReactComponent };